import React from 'react';
import parse from 'html-react-parser';
import { Box, Typography, Stack, Breadcrumbs } from '@mui/material';
import { neutral } from '../../_foundations/phxColors';

export interface PageHeaderProps {
  title: string | React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  titleBadge?: React.ReactNode;
  breadcrumbItems?: React.ReactNode[];
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  titleBadge,
  breadcrumbItems = [],
}) => {
  return (
    <Box
      sx={{
        py: 4,
        px: 5,
        borderBottom: '1px solid',
        borderColor: neutral[100],
        bgcolor: neutral[50],
      }}
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        spacing={2}
      >
        <Box>
          {breadcrumbItems && breadcrumbItems.length > 0 && (
            <Breadcrumbs
              aria-label='breadcrumb'
              sx={{ mb: 5 }}
            >
              {breadcrumbItems}
            </Breadcrumbs>
          )}
          <Stack
            direction='row'
            spacing={2}
            alignItems='center'
          >
            {typeof title === 'string' ? (
              <Typography
                variant='displaySm'
                color='text.primary'
              >
                {parse(title)}
              </Typography>
            ) : (
              title
            )}
            {titleBadge}
          </Stack>
          {subtitle && (
            <Box sx={{ mt: title ? 2 : 0 }}>
              {typeof subtitle === 'string' ? (
                <Typography
                  variant='bodyMd'
                  color='text.secondary'
                >
                  {parse(subtitle)}
                </Typography>
              ) : (
                subtitle
              )}
            </Box>
          )}
        </Box>
        {actions && <Box>{actions}</Box>}
      </Stack>
    </Box>
  );
};
